import { Component, OnInit, input, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { GlobalStore } from '@maximizer/core/shared/data-access';
import { UserRights } from '@maximizer/core/shared/domain';
import { InsightsService } from '@maximizer/core/shared/insights';
import { SummaryAppointmentComponent } from '@maximizer/outlook/appointment/ui';
import { SummaryCaseComponent } from '@maximizer/outlook/case/ui';
import { SummaryNoteComponent } from '@maximizer/outlook/note/ui';
import { SummaryOpportunityComponent } from '@maximizer/outlook/opportunity/ui';
import {
  OutlookAbEntryDetails,
  OutlookLeadSearch,
} from '@maximizer/outlook/shared/domain';
import {
  OUTLOOK_SHARED_UI,
  OutlookNotificationComponent,
} from '@maximizer/outlook/shared/ui';
import { SummaryTaskComponent } from '@maximizer/outlook/task/ui';

@Component({
  selector: 'maximizer-entry-summary',
  templateUrl: './entry-summary.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    OUTLOOK_SHARED_UI,
    SummaryAppointmentComponent,
    SummaryCaseComponent,
    SummaryNoteComponent,
    SummaryOpportunityComponent,
    SummaryTaskComponent,
  ],
})
export class EntrySummaryComponent implements OnInit {
  abentry = input<OutlookAbEntryDetails>();
  lead = input<OutlookLeadSearch>();
  id = input('');
  type = input('');
  deepLink = input<string>();
  oppLink = input<string>();
  csLink = input<string>();

  notification = viewChild<OutlookNotificationComponent>('notification');

  loadingTasks = true;
  loadingNotes = true;
  loadingAppointments = true;
  loadingOpportunities = true;
  loadingCases = true;
  loading = true;
  userRights?: UserRights;

  constructor(
    private readonly insights: InsightsService,
    public globalStore: GlobalStore,
  ) {}

  ngOnInit(): void {
    if (this.globalStore.session()?.user) {
      this.userRights = this.globalStore.session()?.user.rights;
    }
  }

  showNotification(event: string) {
    this.insights.trackException({
      exception: new Error('Failed to load ' + event),
    });
    if (this.notification()?.lastNotification) return;
    this.notification()?.show('load', 'error');
  }

  setLoading(event: string) {
    switch (event) {
      case 'task':
        this.loadingTasks = false;
        break;
      case 'note':
        this.loadingNotes = false;
        break;
      case 'appointment':
        this.loadingAppointments = false;
        break;
      case 'opportunity':
        this.loadingOpportunities = false;
        break;
      case 'case':
        this.loadingCases = false;
        break;
      default:
        break;
    }
    if (this.abentry()) {
      this.loading =
        this.loadingTasks ||
        this.loadingNotes ||
        this.loadingAppointments ||
        this.loadingOpportunities ||
        this.loadingCases;
    } else {
      this.loading =
        this.loadingTasks || this.loadingNotes || this.loadingAppointments;
    }
  }
}
